var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M18.17 37.57v-.47a8.23 8.23 0 0 0-4.55-7.37l-3.68-1.84a.6.6 0 0 1-.34-.54v-3.56a2.27 2.27 0 0 0-1.55-2.16l-1-.34a1 1 0 0 0-1.25.9v6.32a7.3 7.3 0 0 0 2.14 5.16l3.9 3.9h-1.38V42a.32.32 0 0 0 .33.32h8.34a.32.32 0 0 0 .33-.32v-4.43zM18.17 37.57h-6.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "m12.17 33.29-3.52-3.21a1.12 1.12 0 0 1 .23-1.82l.88-.46M30.33 37.57v-.47a8.22 8.22 0 0 1 4.56-7.37l3.67-1.84a.6.6 0 0 0 .34-.54v-3.56a2.27 2.27 0 0 1 1.55-2.16l1-.34a.94.94 0 0 1 1.25.9v6.32a7.3 7.3 0 0 1-2.14 5.16l-3.9 3.9H38V42a.32.32 0 0 1-.33.32h-8.3a.32.32 0 0 1-.32-.32v-4.43zM30.33 37.57h6.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "m36.33 33.29 3.52-3.21a1.12 1.12 0 0 0-.23-1.82l-.87-.46M15.84 5.75v22.37h17.21V9.89l-4.31-4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M28.74 5.75v4.74h4.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "M20.25 13.49h8.38M20.25 18.58h8.38M20.25 22.88h8.38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h38.5v38.03H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.1b13d13544e6ded12e97d3b009bf3a6a.svg";
export { ForwardRef as ReactComponent };